module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/bingdao.68d5d7e2.mp3";